import React from 'react';
import {classes, style} from './doppe-page-hero-photo.st.css';
import {HtmlObjectHorizontalPosition, HtmlObjectResizeMode, HtmlObjectVerticalPosition} from '@wix/devzai-utils-common';
import {
    DoppePageDefaultImageView,
    DoppePageDefaultImageViewImage
} from "../doppe-page-default-image-view/doppe-page-default-image-view";
import {DoppePageMediaView} from "../doppe-page-media-view/doppe-page-media-view";

export const DoppePageHeroPhoto = React.memo(function DoppePageHeroPhoto(props: DoppePageHeroPhoto.Props) {

    const {
        mediaResource,
        layoutSpec,
        widthSpec,
        innerClassName,

        className,
        ...htmlAttributes
    } = props;

    return (
        <DoppePageMediaView
            {...htmlAttributes}
            className={style(classes.root, className)}
            mediaResource={mediaResource}
            layoutSpec={layoutSpec}
            widthSpec={widthSpec}
            innerClassName={innerClassName}
            mediaResizeMode={HtmlObjectResizeMode.Cover}
            mediaVerticalPosition={HtmlObjectVerticalPosition.Center}
            mediaHorizontalPosition={HtmlObjectHorizontalPosition.Center}
            videoMuted={true}
            autoPlayVideo={true}
            playVideoInLoop={true}
            emptyMediaPlaceholder={(
                <DoppePageDefaultImageView
                    image={DoppePageDefaultImageViewImage.SquareImage2}
                />
            )}
        />
    )
});

export namespace DoppePageHeroPhoto {

    export interface Props extends Pick<DoppePageMediaView.Props, keyof React.HTMLAttributes<any> | 'mediaResource' | 'layoutSpec' | 'widthSpec' | 'innerClassName'> {
    }
}
